type TChangedRange = {
	fromA: number;
	toA: number;
	fromB: number;
	toB: number;
};

const getLineCount = (value: string): number => {
	if (value.length === 0) {
		return 1;
	}

	return value.split("\n").length;
};

export const getRenderedEditorValue = (
	value: string,
	minimumLineCount: number
): string => {
	if (minimumLineCount <= 1) {
		return value;
	}

	const missingLineCount = Math.max(
		minimumLineCount - getLineCount(value),
		0
	);

	return `${value}${"\n".repeat(missingLineCount)}`;
};

export const getStoredEditorValue = (
	value: string,
	previousValue: string,
	mappedPreviousValueEnd: number,
	changedRanges: Array<TChangedRange>
): string => {
	if (changedRanges.length === 0) {
		return value;
	}

	let nextValueEnd = mappedPreviousValueEnd;
	const previousValueEnd = previousValue.length;

	changedRanges.forEach((changedRange) => {
		if (changedRange.toA > previousValueEnd) {
			nextValueEnd = Math.max(
				nextValueEnd,
				changedRange.toB
			);
			return;
		}

		if (changedRange.fromA >= previousValueEnd) {
			nextValueEnd = Math.max(
				nextValueEnd,
				changedRange.toB
			);
		}
	});

	return value.slice(0, nextValueEnd);
};
